import { GfeFilters, GfeSelectedRow } from "../types/gfe_types";

export enum GfeActionType {
  SET_FILTER = "SET_FILTER",
  RESET_FILTERS = "RESET_FILTERS",
  SET_PAGE = "SET_PAGE",
  SET_PAGE_SIZE = "SET_PAGE_SIZE",
  OPEN_EDIT = "OPEN_EDIT",
  OPEN_DELETE = "OPEN_DELETE",
  CLOSE_MODAL = "CLOSE_MODAL",
  SET_ERROR = "SET_ERROR",
}

export type GfeAction =
  | { type: GfeActionType.SET_FILTER; payload: Partial<GfeFilters> }
  | { type: GfeActionType.RESET_FILTERS }
  | { type: GfeActionType.SET_PAGE; payload: number }
  | { type: GfeActionType.SET_PAGE_SIZE; payload: number }
  | { type: GfeActionType.OPEN_EDIT; payload: GfeSelectedRow }
  | { type: GfeActionType.OPEN_DELETE; payload: GfeSelectedRow }
  | { type: GfeActionType.CLOSE_MODAL }
  | { type: GfeActionType.SET_ERROR; payload: string | undefined };
